import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Paper, Typography, IconButton, Fade } from '@material-ui/core'
import { Close, EmojiObjects } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
  notification: {
    position: 'absolute',
    left: '100%',
    top: '50%',
    transform: 'translateY(-50%)',
    marginLeft: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    border: '2px solid #d05d02',
    borderRadius: '12px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
    zIndex: 10000,
    maxWidth: '280px',
    minWidth: '250px',
    animation: '$pulse 2s infinite',
  },
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 8px 24px rgba(208, 93, 2, 0.15)',
    },
    '50%': {
      boxShadow: '0 8px 24px rgba(208, 93, 2, 0.4)',
    },
    '100%': {
      boxShadow: '0 8px 24px rgba(208, 93, 2, 0.15)',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: '#d05d02',
    fontWeight: 'bold',
    fontSize: '16px',
  },
  content: {
    color: '#333',
    fontSize: '14px',
    lineHeight: 1.4,
  },
  closeButton: {
    padding: '4px',
    color: '#999',
  },
  lightbulb: {
    color: '#ffc107',
    fontSize: '20px',
  },
  arrow: {
    position: 'absolute',
    left: '-8px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: 0,
    height: 0,
    borderTop: '8px solid transparent',
    borderBottom: '8px solid transparent',
    borderRight: '8px solid #d05d02',
  },
}))

function SupportNotification({ onClose }) {
  const classes = useStyles()
  const [show, setShow] = useState(false)

  useEffect(() => {
    // Verifica se já foi mostrado antes
    const hasSeenNotification = localStorage.getItem('supportNotificationSeen')
    
    if (!hasSeenNotification) {
      // Mostra após um pequeno delay para dar tempo do menu carregar
      const timer = setTimeout(() => {
        setShow(true)
      }, 1500)

      return () => clearTimeout(timer)
     }
  }, [])

  const handleClose = () => {
    setShow(false)
    // Marca como visto no localStorage
    localStorage.setItem('supportNotificationSeen', 'true')
    if (onClose) onClose()
  }



  if (!show) return null

  return (
    <Fade in={show}>
      <Paper className={classes.notification}>
        <div className={classes.arrow} />
        
        <div className={classes.header}>
          <div className={classes.title}>
            <EmojiObjects className={classes.lightbulb} />
            <span>Novidade!</span>
          </div>
          <IconButton 
            className={classes.closeButton}
            onClick={handleClose}
            size="small"
          >
            <Close fontSize="small" />
          </IconButton>
        </div>

        <Typography className={classes.content}>
          Agora você pode solicitar suporte técnico diretamente pela Agenda! 
          Clique aqui para acessar nosso atendimento especializado.
        </Typography>
      </Paper>
    </Fade>
  )
}

export default SupportNotification